import type { TaxIdType } from "./TaxIdType";
import { getTaxIdTypes } from "./taxIdTypes/index";

export const areThereAnyTaxIdsForCountry = (countryCode: string) =>
  getTaxIdTypes().some(t => t.countryCode === countryCode);

export const isValidTaxIdValue = ({
  taxIdEnum,
  taxIdValue,
  countryCode,
}: {
  taxIdEnum: string;
  taxIdValue: string;
  countryCode?: string;
}) => {
  const taxIdType = getTaxIdTypes().find(
    t => t.enum === taxIdEnum && t.countryCode === countryCode,
  );
  if (!taxIdType) {
    return false;
  }

  if (taxIdType.formOptions?.pattern) {
    return taxIdType.formOptions.pattern.test(taxIdValue);
  }

  return true;
};

export const mapTaxIdTypeToOptions = (entry: TaxIdType) => ({
  value: entry.label,
  text: entry.label,
});

export const getTaxIdTypeLabelByTaxIdTypeAndCountryCode = (
  taxIdType: string | undefined,
  countryCode: string | undefined,
) => {
  const match = getTaxIdTypes().find(
    entry => entry.enum === taxIdType && entry.countryCode === countryCode,
  );
  return match?.label ?? "";
};

export const getTaxIdTypeByLabel = (label: string | undefined) =>
  getTaxIdTypes().find(entry => entry.label === label);

export const filterTaxIdTypeOptionBySearchValue = (
  option: { value: string; text: string },
  searchValue: string,
) => {
  const searchValueLower = searchValue.toLowerCase();
  return (
    option.value.toLowerCase().includes(searchValueLower) ||
    option.text.toLowerCase().includes(searchValueLower)
  );
};

export const getBrazilCpfTaxIdType = () =>
  getTaxIdTypes().find(type => type.enum === "br_cpf");
